export function capitalize (nameString) {
  if (typeof nameString === 'string') {
    return nameString
      .split(' ')
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ')
  }
  return nameString
}
